import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#F3F1EC] mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20 grid grid-cols-1 md:grid-cols-3 gap-14">
        <div>
          <div className="font-script text-5xl leading-tight">Harry's</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A6A6A0] mt-2 font-medium">
            Salotto &amp; Cucina
          </div>
          <p className="mt-6 text-sm leading-relaxed text-[#A6A6A0] max-w-xs">
            {t("about.body").slice(0, 140)}…
          </p>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#A6A6A0]">
            {t("footer.contact")}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#8B3A3A]" strokeWidth={1.5} />
              <span>{info?.address || "P.zt Andrea Palladio, 8 — Vicenza"}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#8B3A3A]" strokeWidth={1.5} />
              <a href={`tel:${info?.phone}`} className="link-underline">{info?.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#8B3A3A]" strokeWidth={1.5} />
              <a href={`mailto:${info?.email}`} className="link-underline">{info?.email}</a>
            </li>
            <li className="text-[#A6A6A0] pt-2">
              {info?.hours?.[i18n.language] || info?.hours?.it}
            </li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#A6A6A0]">
            {t("footer.links")}
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/menu" className="link-underline">{t("nav.menu")}</Link></li>
            <li><Link to="/prenota" className="link-underline">{t("nav.reservation")}</Link></li>
            <li><Link to="/dove-siamo" className="link-underline">{t("nav.location")}</Link></li>
            <li><Link to="/da-vedere" className="link-underline">{t("nav.vicenza")}</Link></li>
            <li><Link to="/lavora-con-noi" className="link-underline">{t("nav.careers")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 text-xs tracking-wider text-[#A6A6A0] flex justify-between">
          <span>© {new Date().getFullYear()} Harry's Salotto e Cucina</span>
          <span>{t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
}
